import type { ValuesPayload } from '@atlaskit/config-common-libs';
import { ConfigCollection } from '@atlaskit/config-common-libs';

declare global {
	interface Window {
		__STATSIGCONFIGS_JS__: StatsigConfigurations;
	}
}

class StatsigConfigurations {
	static configCollection: ConfigCollection;

	static initializeFromValues(configCollectionValues: ValuesPayload) {
		this.configCollection = ConfigCollection.fromValues(configCollectionValues);
	}
}

/* eslint-disable import/no-default-export */
export default StatsigConfigurations;
